// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadReorderPad, { defaultReorderPadParameters } from "@steiner/App/Handlers/ReorderPad/LoadReorderPad";
import loadOpenBids from "@steiner/App/Handlers/XNG/LoadOpenBids";
import { ReorderPadModel } from "@steiner/App/Services/ReorderPad";
import { CustomAppState } from "@steiner/App/Store/Reducers";

type HandlerType = Handler<HasOnSuccess, ReorderPadModel>;

export const DispatchCleareorderPadSearchParams: HandlerType = props => {
    props.dispatch({ type: "xReorderPad/ClearSearchParams" } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [DispatchCleareorderPadSearchParams, ExecuteOnSuccessCallback];

const clearReorderPadSearchParams = createHandlerChainRunner(chain, "ClearReorderPadSearchParams");

export default clearReorderPadSearchParams;
